import React, { Fragment, useEffect } from 'react';
import CategoryLink from '../Components/CategoryLink';

const Navigation = ({ links = [], contentLink = null }) => {
    let menuRef = React.createRef();
    function toggleMenu() {
        if (menuRef.current.classList.toggle('navbar__menu--show')) {
            document
                .querySelectorAll('.navbar__item.image-column-holder')
                .forEach(x => x.classList.add('hidden'));
                document.body.classList.add('no-scroll'); 
    
        } else {
            document
                .querySelectorAll('.navbar__item.image-column-holder')
                .forEach(x => x.classList.remove('hidden'));
                document.body.classList.remove('no-scroll'); 
        }
    }

    function toggleMobileMenu() {
        const navbar = document.getElementById('navbar');
        const menuCtaLinks = document
            .getElementsByClassName('cta-header-links')[0]
            .getElementsByClassName('navbar__item');

        document
            .querySelectorAll('.navbar__item.image-column-holder')
            .forEach(x => x.classList.remove('hidden'));



        if (navbar && navbar.getElementsByClassName('navbar__menu')) {
            let menus = navbar.getElementsByClassName('navbar__menu');
            menus[0].classList.add('navbar__menu--show');
            let ctaNavLinks = navbar.getElementsByClassName('cta-menu-link');

            if (menus[0].classList.contains('navbar__menu--show')) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }

            for (var i = 0; i < ctaNavLinks.length; i++) {
                menuCtaLinks[i].classList.remove('navbar__menu--show');
                let ctaMenu =
                    ctaNavLinks[i].getElementsByClassName('navbar__menu')[0];
                menuCtaLinks[i].classList.remove('active');
                ctaMenu.classList.remove('navbar__menu--show');
            }
            let ctaMenu =
                ctaNavLinks[0].getElementsByClassName('navbar__menu')[0];
            if (ctaMenu) {
                menuCtaLinks[0].classList.add('active');
                ctaMenu.classList.add('navbar__menu--show');
            } else {
                menuRef.current.classList.remove('navbar__menu--show');
            }
        }
    }



    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link =>
        link.name || (link.links || []).length > 0;

    const navbarClass = links.some(link => link.isImages === true)
    ? 'navbar__menu image-column'
    : 'navbar__menu'
    const navbarChildClass = contentLink ? 'navbar__menu--child' : '';


    return links.length < 1 && !contentLink ? (
        <></>
    ) : (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMobileMenu}
                >
                    <img
                        className="light-icon"
                        src="/ui/images/menu-burger.svg"
                        alt="Nav icon"
                    />
                </a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                        style={{ color: `#${contentLink.hexCode}` }}
                    ></a>
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}


            {links.length > 0 && (
                <ul
                    className={`${navbarClass} ${navbarChildClass}`}
                    ref={menuRef}
                >
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <div className="mobile-menu-top">
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ></span>
                            </div>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    {/* Display only first 3 cta items in list (Woman, Man, Tools) */}
                    <CategoryLink
                        links={links.filter(a => a.cta).slice(0, 3)}
                    />
                    {links.map(
                        (link, i) =>
                            hasNameOrChildren(link) && !link.hide && (
                                <li
                                    className={
                                        'navbar__item ' +
                                        (link.cta ? 'cta-menu-link ' : '') +
                                        (link.mobileOnly
                                            ? 'mobile-only '
                                            : '') +
                                        (link.desktopOnly
                                            ? 'desktop-only '
                                            : '') +
                                        (link.alwaysOpen ? 'always-open' : '') +
                                        (link.links.some(link => link.isImages)
                                            ? 'image-column-holder'
                                            : '')
                                    }
                                    key={
                                        !link.name
                                            ? `${new Date().getTime()}-${i}`
                                            : `${link.name}-${i}`
                                    }
                                >
                                    {!link.isImages ? (
                                        <Navigation
                                            links={link.links}
                                            contentLink={link}
                                        />
                                    ) : (
                                        <a
                                            href={link.url}
                                            className="card card--simple"
                                        >
                                            <img
                                                className="card__image"
                                                itemProp="image"
                                                src={link.imageUrl}
                                            />
                                            <div className="card__overlay"></div>
                                            <div className="card__content">
                                                <span className="card__title">
                                                    {link.name}
                                                </span>
                                            </div>
                                        </a>
                                    )}
                                </li>
                            ),
                    )}
                </ul>
            )}
        </Fragment>
    );
};

export default Navigation;
